import Select from "@/Components/Select/Select";
import { themeListAtom } from "@/shared/atoms";
import { themeType } from "@/shared/utils/constant";
import { useAtom } from "jotai";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const ColorTemplate = () => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });
  const { control } = useFormContext();
  const [themeList] = useAtom(themeListAtom);

  return (
    <div data-tour="website-settings.color-template" className="mb-[1rem]">
      <h2> {t(`colorTemplate`)}</h2>
      <Controller
        name="colorTemplate"
        control={control}
        render={({ value, onChange }) => (
          <Select
            onChange={(val) => onChange(val)}
            options={themeList.filter((i) => i.themeType === themeType.CUSTOM)}
            getOptionLabel={(option) => option.template_name}
            getOptionValue={(option) => option.item_id}
            value={value}
          />
        )}
      />
    </div>
  );
};

export default ColorTemplate;
